import DateHelper from "~/ts/library/Date";
import {__} from "~/ts/library/Translate";

export default function getTimeStringByTimestamp(value: number): string {
    let dt = (new DateHelper(value)).dateObject;
    let today = new Date();
    let result: string;
    if (dt.toDateString() === today.toDateString()) {
        result = dt.toTimeString().substr(0, 5);
    } else {
        let nowTimestamp = Math.ceil(today.getTime() / 1000);
        var dtTimestamp = Math.ceil(dt.getTime() / 1000);
        if (nowTimestamp - dtTimestamp < 86400 * 6) {
            let day = dt.getDay();
            const days = [__('Вс'), __('Пн'), __('Вт'), __('Ср'), __('Чт'), __('Пт'), __('Сб')];
            result = days[day];
        } else {
            result = dt.toLocaleDateString();
        }
    }
    return result;
}